import { C } from '../../theme.js';
import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function StripCharsInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel hint="Each character is stripped individually">Characters to strip</FieldLabel>
      <TextInput mono value={c.chars} onChange={(v) => u({ chars: v })} placeholder={'e.g.  -,.()'} />
      <FieldLabel>Presets</FieldLabel>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {[
          { label: 'Punctuation', chars: '.,;:!?\'"' },
          { label: 'Brackets', chars: '()[]{}' },
          { label: 'Symbols', chars: '@#$%^&*' },
          { label: 'Currency', chars: '$€£¥' },
        ].map(p => (
          <button key={p.label} onClick={() => u({ chars: p.chars })} style={{
            fontFamily: 'inherit', cursor: 'pointer',
            background: C.input, color: C.fg3, border: `1px solid ${C.border}`,
            borderRadius: 6, padding: '4px 9px', fontSize: '.74rem', fontWeight: 600,
          }}>{p.label}</button>
        ))}
      </div>
    </div>
  );
}
